// Mock data for the luxury hotel website

export const hotelInfo = {
  name: "OlivOak Villa",
  tagline: "Refined Comfort. Tranquil Living.",
  description: "Luxury accommodation in Zimbabwe",
  location: {
    address: "14180 Gunhill Avenue, Harare, Zimbabwe",
    coordinates: { lat: -17.7905851, lng: 31.0727272 }
  },
  contact: {
    phone: "+263 78 937 4888",
    phone2: "+263 78 593 3336",
    email: "reservations@olivoakvilla.com",
    email2: "info@olivoakvilla.com",
    whatsapp: "+263 78 937 4888"
  },
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61579702750758",
    instagram: "https://www.instagram.com/olivoakvilla",
    whatsappLink: "https://wa.me/263789374888"
  }
};

export const rooms = [
  {
    id: "deluxe-suite",
    name: "Deluxe Suite",
    description: "Spacious elegance with garden views and private terrace",
    shortDescription: "Garden views, private terrace, king bed",
    occupancy: { max: 2, beds: "1 King Bed" },
    size: "45 sqm",
    price: {
      USD: 180,
      ZAR: 3240,
      GBP: 140,
      EUR: 165
    },
    images: [
      "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxob3RlbCUyMGJhdGhyb29tfGVufDB8fHx8MTc2NzU2NDk1MHww&ixlib=rb-4.1.0&q=85"
    ],
    amenities: [
      "Air Conditioning",
      "King Size Bed",
      "Private Terrace",
      "Garden View",
      "Mini Bar",
      "Luxury Bathroom",
      "Free Wi-Fi",
      "Smart TV"
    ],
    available: true
  },
  {
    id: "executive-room",
    name: "Executive Room",
    description: "Contemporary comfort with modern amenities",
    shortDescription: "Pool view, work desk, queen bed",
    occupancy: { max: 2, beds: "1 Queen Bed" },
    size: "35 sqm",
    price: {
      USD: 140,
      ZAR: 2520,
      GBP: 110,
      EUR: 130
    },
    images: [
      "https://images.unsplash.com/photo-1618773928121-c32242e63f39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGJhdGhyb29tfGVufDB8fHx8MTc2NzU2NDk1MHww&ixlib=rb-4.1.0&q=85"
    ],
    amenities: [
      "Air Conditioning",
      "Queen Size Bed",
      "Work Desk",
      "Pool View",
      "Coffee Maker",
      "Rainfall Shower",
      "Free Wi-Fi",
      "Smart TV"
    ],
    available: true
  },
  {
    id: "luxury-villa",
    name: "Luxury Villa",
    description: "Ultimate privacy with dedicated butler service",
    shortDescription: "Private pool, butler service, two bedrooms",
    occupancy: { max: 4, beds: "2 King Beds" },
    size: "85 sqm",
    price: {
      USD: 350,
      ZAR: 6300,
      GBP: 275,
      EUR: 320
    },
    images: [
      "https://images.unsplash.com/photo-1607712617949-8c993d290809?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1604348825621-22800b6ed16d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxob3RlbCUyMHBvb2x8ZW58MHx8fHwxNzY3NDYxMzQxfDA&ixlib=rb-4.1.0&q=85"
    ],
    amenities: [
      "Private Pool",
      "Butler Service",
      "Two Bedrooms",
      "Living Room",
      "Full Kitchen",
      "Private Garden",
      "Luxury Bathrooms",
      "Free Wi-Fi"
    ],
    available: true
  },
  {
    id: "standard-room",
    name: "Standard Room",
    description: "Comfortable retreat with essential luxuries",
    shortDescription: "City view, double bed, compact elegance",
    occupancy: { max: 2, beds: "1 Double Bed" },
    size: "28 sqm",
    price: {
      USD: 110,
      ZAR: 1980,
      GBP: 85,
      EUR: 100
    },
    images: [
      "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxob3RlbCUyMGJhdGhyb29tfGVufDB8fHx8MTc2NzU2NDk1MHww&ixlib=rb-4.1.0&q=85"
    ],
    amenities: [
      "Air Conditioning",
      "Double Bed",
      "City View",
      "Compact Desk",
      "Tea & Coffee",
      "Shower",
      "Free Wi-Fi",
      "TV"
    ],
    available: true
  }
];

export const facilities = [
  {
    name: "Swimming Pool",
    icon: "Waves",
    description: "Outdoor pool with lounge area"
  },
  {
    name: "Gardens",
    icon: "Trees",
    description: "Landscaped gardens with walking paths"
  },
  {
    name: "Secure Parking",
    icon: "Car",
    description: "24-hour monitored parking facility"
  },
  {
    name: "High-Speed Wi-Fi",
    icon: "Wifi",
    description: "Complimentary fiber internet throughout property"
  },
  {
    name: "Breakfast",
    icon: "UtensilsCrossed",
    description: "Lunch and dinner available on request"
  }
  
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Thompson",
    country: "United Kingdom",
    rating: 5,
    comment: "Absolutely stunning property. The attention to detail and service exceeded all expectations. A true sanctuary.",
    date: "2025-07-15"
  },
  {
    id: 2,
    name: "Michael Chen",
    country: "Singapore",
    rating: 5,
    comment: "The perfect blend of luxury and tranquility. Staff were exceptional, rooms immaculate. Will definitely return.",
    date: "2025-07-10"
  },
  {
    id: 3,
    name: "Emma van der Berg",
    country: "South Africa",
    rating: 5,
    comment: "From the moment we arrived, we felt welcomed. Beautiful gardens, excellent cuisine, and peaceful atmosphere.",
    date: "2025-06-28"
  },
  {
    id: 4,
    name: "David Martinez",
    country: "Spain",
    rating: 5,
    comment: "An oasis of calm. The villa exceeded our expectations. Highly recommend for those seeking refined luxury.",
    date: "2025-06-20"
  }
];

export const galleryImages = [
  {
    category: "Rooms",
    url: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Luxury hotel room with natural lighting"
  },
  {
    category: "Rooms",
    url: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Executive room with modern design"
  },
  {
    category: "Rooms",
    url: "https://images.unsplash.com/photo-1607712617949-8c993d290809?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMHJvb218ZW58MHx8fHwxNzY3NDY0NjI0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Luxury villa bedroom"
  },
  {
    category: "Facilities",
    url: "https://images.unsplash.com/photo-1623718649591-311775a30c43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxob3RlbCUyMHBvb2x8ZW58MHx8fHwxNzY3NDYxMzQxfDA&ixlib=rb-4.1.0&q=85",
    alt: "Luxury pool area"
  },
  {
    category: "Facilities",
    url: "https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGxvYmJ5fGVufDB8fHx8MTc2NzU2NDkzNHww&ixlib=rb-4.1.0&q=85",
    alt: "Hotel lobby"
  },
  {
    category: "Facilities",
    url: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGRpbmluZ3xlbnwwfHx8fDE3Njc1NjQ5NTV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Fine dining restaurant"
  },
  {
    category: "Exterior",
    url: "https://images.unsplash.com/photo-1607320895054-c5c543e9a069?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxob3RlbCUyMGV4dGVyaW9yfGVufDB8fHx8MTc2NzU2NDk0NHww&ixlib=rb-4.1.0&q=85",
    alt: "Hotel exterior view"
  },
  {
    category: "Exterior",
    url: "https://images.unsplash.com/photo-1668480441891-3744c25337a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxob3RlbCUyMGV4dGVyaW9yfGVufDB8fHx8MTc2NzU2NDk0NHww&ixlib=rb-4.1.0&q=85",
    alt: "Hotel building architecture"
  }
];

export const reviews = [
  {
    id: 1,
    guestName: "James Wilson",
    country: "Australia",
    rating: 5,
    reviewText: "Exceptional service from start to finish. The rooms are beautifully appointed, and the staff goes above and beyond. The breakfast was outstanding, and the location is perfect for exploring Harare.",
    date: "2025-07-18",
    verified: true
  },
  {
    id: 2,
    guestName: "Sophie Laurent",
    country: "France",
    rating: 5,
    reviewText: "We spent our honeymoon here and it was magical. The villa with private pool was worth every penny. Romantic, secluded, and the butler service made us feel like royalty.",
    date: "2025-07-12",
    verified: true
  },
  {
    id: 3,
    guestName: "Robert Nkomo",
    country: "Zimbabwe",
    rating: 4,
    reviewText: "Beautiful property with excellent facilities. The spa treatments were divine. Only minor issue was Wi-Fi speed in some areas, but overall a wonderful stay.",
    date: "2025-07-05",
    verified: true
  },
  {
    id: 4,
    guestName: "Lisa Anderson",
    country: "United States",
    rating: 5,
    reviewText: "Stayed for a business trip and was blown away. The executive room had everything I needed to work comfortably, and the restaurant's food quality rivaled top establishments.",
    date: "2025-06-30",
    verified: true
  },
  {
    id: 5,
    guestName: "Carlos Rodriguez",
    country: "Brazil",
    rating: 5,
    reviewText: "Impeccable hospitality. The attention to detail is remarkable - from the turndown service to the personalized welcome. A true gem in Harare.",
    date: "2025-06-25",
    verified: true
  }
];

export const mockUser = {
  id: "user-001",
  email: "guest@example.com",
  firstName: "John",
  lastName: "Doe",
  phone: "+1 234 567 8900",
  bookings: [
    {
      id: "booking-001",
      bookingReference: "SL2025-001",
      roomId: "deluxe-suite",
      roomName: "Deluxe Suite",
      checkIn: "2025-09-15",
      checkOut: "2025-09-20",
      guests: 2,
      totalPrice: 900,
      currency: "USD",
      status: "confirmed",
      createdAt: "2025-07-20T10:30:00Z"
    }
  ]
};
